import { Box, Stack, Typography } from "@mui/material"
import QRCode from "qrcode"
import {
    getSchedulePDFFooterQRCodeCaption,
    getSchedulePDFFooterQRCodeUrl,
} from "routes/schedule/schedule-pdf-presenters"
import { useEffect, useState } from "react"

const QR_CODE_SIZE = 54

export function SchedulePDFFooterQRCode({ badgeUrl, scheduleUrl }) {
    const [qrCodeUrl, setQrCodeUrl] = useState("")
    const targetUrl = getSchedulePDFFooterQRCodeUrl({ badgeUrl, scheduleUrl })
    const captionLines = getSchedulePDFFooterQRCodeCaption({ badgeUrl })

    useEffect(() => {
        let cancelled = false

        if (!targetUrl) {
            setQrCodeUrl("")
            return noop
        }

        QRCode.toDataURL(targetUrl, { margin: 0, width: 128 })
            .then((dataUrl) => {
                if (!cancelled) setQrCodeUrl(dataUrl)
            })
            .catch((error) => {
                console.warn("Failed to generate schedule PDF footer QR code", error)
                if (!cancelled) setQrCodeUrl("")
            })

        return () => {
            cancelled = true
        }
    }, [targetUrl])

    if (!qrCodeUrl) return null

    return (
        <Stack
            className="schedule-pdf-footer-qr-code"
            data-cy="schedule-pdf-footer-qr-code"
            direction="row"
            alignItems="center"
            spacing={0.75}
            sx={{ flexShrink: 0 }}
        >
            <Box
                component="img"
                src={qrCodeUrl}
                alt="QR code to verify SFG20 license status"
                sx={{ display: "block", width: QR_CODE_SIZE, height: QR_CODE_SIZE }}
            />
            <Box sx={{ lineHeight: 1.05, minWidth: 68 }}>
                <Typography variant="caption" color="text.secondary" display="block">
                    {captionLines[0]}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                    {captionLines[1]}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                    {captionLines[2]}
                </Typography>
            </Box>
        </Stack>
    )
}

function noop() {}
